import { render, staticRenderFns } from "./MechanismList.vue?vue&type=template&id=22dd1d2e&scoped=true"
import script from "./MechanismList.vue?vue&type=script&lang=js"
export * from "./MechanismList.vue?vue&type=script&lang=js"
import style0 from "./MechanismList.vue?vue&type=style&index=0&id=22dd1d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd1d2e",
  null
  
)

export default component.exports